import { Component, Output, EventEmitter, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-notifications-header',
  templateUrl: './notifications-header.component.html',
  styleUrls: ['./notifications-header.component.scss']
})
export class NotificationsHeaderComponent {
  @Input() selectedFilter: 'all' | 'unread' = 'all';
  @Input() hasUnreadNotifications = false;
  @Input() unreadCount = 0;
  @Output() filterChange = new EventEmitter<'all' | 'unread'>();
  @Output() markAllAsRead = new EventEmitter<void>();
  @Output() closeNotifications = new EventEmitter<void>();

  constructor(private translateService: TranslateService) {}

  onFilterChange(filter: 'all' | 'unread'): void {
    this.filterChange.emit(filter);
  }
} 